import React from 'react'
import './index.less'

import http from 'src/helper/http'
import { setDocumentTitle } from 'src/helper/tool'
import { history } from 'src/core/router'
import { jumpToUser } from '../../../helper/devTools'
// import { observable, action, autorun, computed, toJS } from 'mobx'
import brower from 'src/helper/brower'
// import cdn from 'src/helper/cdn'
// import cdn from 'src/helper/avatar'
import score from 'src/helper/score'
export default class extends React.Component {
  state = {

  }

  constructor(props) {
    super(props)
  }

  async componentWillMount() {
  }

  componentDidMount() {

  }

  render() {
    let {
      rankList,
      currentRanking,
      uid,
    } = this.props.store
    let { isOpenRank, lang } = this.props
    return (
      <div
        style={{ transform: `translateY(${isOpenRank ? "0" : "100vh"})` }}
        className={`rank_page ${isOpenRank ? "openPopupRank" : "none"}`}
        onClick={(e) => { this.props.onCloseRank() }}>
        <div className={`rank_box`} onClick={(e) => { e.stopPropagation() }}>
          <div className='title'>{lang.rankList} <img src="/img/activity/fruitgame/icon-close.png" onClick={() => this.props.onCloseRank()} /></div>
          <div className='rank_list'>
            {
              rankList.map((r, i) => {
                return (
                  <div className='every_rank' key={i}>
                    <div className='rank'>{r.rank > 3 ? r.rank : ""}</div>
                    <div className='user'>
                      <div className='avater' onClick={() => { jumpToUser(r && r.uid) }}><img src={r.avatarurl} /></div>
                      <div className='info'>
                        <div className='name'>{r.nickname}</div>
                        <div className='id_num'>ID:{r.duid}</div>
                      </div>
                    </div>
                    <div className='num'><img src="/img/gold.png" /> {score(r.val)}</div>
                  </div>
                )
              })
            }


          </div>
          {
            isOpenRank && currentRanking.rank != 0 &&
            <div className='my_rank'>
              <div className={`rank ${currentRanking.rank == 1 ? "rank1" : currentRanking.rank == 2 ? "rank2" : currentRanking.rank == 3 ? "rank3" : ""}`}>{currentRanking.rank}</div>
              <div className='user'>
                <div className='avater' onClick={() => { jumpToUser(currentRanking && currentRanking.uid) }}><img src={currentRanking.avatarurl} /></div>
                <div className='info'>
                  <div className='name'>{currentRanking.nickname}</div>
                  <div className='id_num'>ID:{currentRanking.uid}</div>
                </div>
              </div>
              <div className='num'><img src="/img/activity/fruitgame/gold_top.png" /> {score(currentRanking.val)}</div>
            </div>
          }
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// src/pages/activity/fruit1103/rank.js